import React from 'react';

export default function SkipToContent() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const main = document.getElementById('main');
    if (main) {
      main.scrollIntoView({ behavior: 'smooth', block: 'start' });
      main.focus({ preventScroll: true });
    }
  };

  return (
    <a
      href="#main"
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-50 bg-white text-black px-3 py-2 rounded-md shadow-lg border border-border"
    >
      Skip to content
    </a>
  );
}
